import { render } from "./UserExitSetting.vue?vue&type=template&id=09c776e6&scoped=true"
import script from "./UserExitSetting.vue?vue&type=script&lang=js"
export * from "./UserExitSetting.vue?vue&type=script&lang=js"

import "./UserExitSetting.vue?vue&type=style&index=0&id=09c776e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c776e6"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/UserExitSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09c776e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09c776e6', __exports__)) {
    api.reload('09c776e6', __exports__)
  }
  
  module.hot.accept("./UserExitSetting.vue?vue&type=template&id=09c776e6&scoped=true", () => {
    api.rerender('09c776e6', render)
  })

}


export default __exports__